import { Box } from "@mui/material";

const Skeleton = ({
  height = 56,
  width = "100%",
  component = "div",
  borderRadius = "md-round",
  ...props
}) => (
  <Box
    height={height}
    width={width}
    component={component}
    bgcolor="var(--surface-container-low)"
    borderRadius={`var(--shape-${borderRadius})`}
    sx={{ animation: "pulse 4s var(--motion-easing-emphasized) 1s infinite" }}
    {...props}
  />
);

export default Skeleton;
